import { useAuth0 } from '@auth0/auth0-react';
import CircularProgress from "@mui/material/CircularProgress";
import { InputField } from 'components/InputField';
import UserService from 'Lib/API/users/index';
import React, { useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { emailValidation } from 'utils/validation';
import { InvitationModalAction, InvitationModalButton, InvitationModalContainer, InvitationModalContent, InvitationModalTitle } from './Theme';

const InvitationModal = ({ contactId, defaultEmail,closeModal,refreshData }) => {
  const { getAccessTokenSilently } = useAuth0();

  const [email, setEmail] = useState(defaultEmail);
  const [loading, setLoading] = useState(false);

  const inviteHandler = async () => {
    if (!email || !emailValidation(email)) return toastr.info("validation error", "please fill valid email field");
    setLoading(true);
    const bodyData = {
      email,
      contactId
    }
    const token = await getAccessTokenSilently();
    await UserService.inviteUserByEmail(token, bodyData)
      .then((res) => {
        closeModal();
        refreshData();
        toastr.success("Success", "User invited successfully");
      })
      .catch((error) => {
        toastr.error("Error", error?.data?.message ?? "Something Went Wrong");
      }).finally(() => {
        setLoading(false)
      })
  }




  return (
    <InvitationModalContainer>
      <InvitationModalTitle>Enter an email address to invite the user to the members portal</InvitationModalTitle>
      <InvitationModalContent>
        <InputField
          type="text"
          title="Email"
          {...{
            // formik,
            name: 'email',
            placeholder: 'Email',
            value: email
          }}
          handleChange={(e) => {
            setEmail(e?.target?.value)
          }}
          inputClassName="donation__input"
        />
      </InvitationModalContent>
      <InvitationModalAction>
        <InvitationModalButton className="btn btn-primary font-weight-bold px-6 py-3" onClick={inviteHandler} disabled={loading || !email}>
          {loading ? (
            <div className="d-flex justify-content-center align-items-center">
               <CircularProgress
                    size={22}
                    style={{
                      color: "#ffffff",
                    }}
                />
            </div>
          ) : "Invite"}
        </InvitationModalButton>
      </InvitationModalAction>
    </InvitationModalContainer >
  )
}

export default InvitationModal